import FeaturedBrandPreview from './featured-brand-preview.component';

export default FeaturedBrandPreview;
